import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { OvertimeDataSourceService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { ShiftTimelineDataState } from '@wilson/shift-timeline/state';
import { Observable } from 'rxjs';

@Injectable()
export class ShiftTimelineOvertimeDataSourceServiceService extends OvertimeDataSourceService {
  private store = inject(Store);

  override isLoadingUsersOvertimesStream(): Observable<boolean> {
    return this.store.select(ShiftTimelineDataState.isLoadingUsersOvertimes);
  }

  override userOvertimeMinutesStream(
    userId: string,
  ): Observable<number | undefined> {
    return this.store.select(
      ShiftTimelineDataState.userOvertimeMinutesStream(userId),
    );
  }
}
